<template>
  <div class="min-h-screen bg-slate-800 flex items-center justify-center p-8">
    <div class="max-w-md w-full bg-slate-700 border-4 border-amber-600/60 p-8 text-center" style="border-radius: 8px;">
      <h1 class="text-3xl font-serif-display text-amber-200 mb-4">Tracking Disabled</h1>
      <p class="text-amber-100 font-serif-body mb-6">
        Analytics tracking has been disabled for this browser. You will not be tracked across the site.
      </p>
      <div class="space-y-4">
        <a
          href="/"
          class="block w-full bg-amber-600 hover:bg-amber-500 text-white font-serif-display font-bold text-xl py-3 transition-all border-2 border-amber-800"
          style="border-radius: 6px;"
        >
          Return to Game
        </a>
        <a
          href="/internal/enable-tracking"
          class="block w-full bg-slate-600 hover:bg-slate-500 text-amber-200 font-serif-body text-sm py-2 transition-all border-2 border-slate-500"
          style="border-radius: 6px;"
        >
          Re-enable tracking
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  localStorage.setItem('disable-tracking', 'true')
})
</script>
